import { render, staticRenderFns } from "./ExpedientEconomicDataComponent.vue?vue&type=template&id=c31974a8&scoped=true&lang=pug"
import script from "./ExpedientEconomicDataComponent.vue?vue&type=script&lang=ts"
export * from "./ExpedientEconomicDataComponent.vue?vue&type=script&lang=ts"
import style0 from "./ExpedientEconomicDataComponent.vue?vue&type=style&index=0&id=c31974a8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c31974a8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c31974a8')) {
      api.createRecord('c31974a8', component.options)
    } else {
      api.reload('c31974a8', component.options)
    }
    module.hot.accept("./ExpedientEconomicDataComponent.vue?vue&type=template&id=c31974a8&scoped=true&lang=pug", function () {
      api.rerender('c31974a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/expedients/ExpedientEconomicData/ExpedientEconomicDataComponent.vue"
export default component.exports